type CostSummary = {
  totalCents: number;
  byCategory: Partial<Record<string, number>>;
  windowStart: string;
  windowEnd: string;
};

type CostsCardProps = {
  summary: CostSummary;
  tenantName: string;
};

function formatDollars(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}

export function CostsCard({ summary, tenantName }: CostsCardProps) {
  const categories = Object.entries(summary.byCategory)
    .sort((a, b) => (b[1] ?? 0) - (a[1] ?? 0));

  return (
    <div className="rounded-lg border border-slate-800 bg-slate-900/50 p-6">
      {/* Total */}
      <div className="mb-6">
        <p className="text-xs uppercase tracking-widest text-sky-400 mb-1">Total spend</p>
        <p className="text-4xl font-bold">{formatDollars(summary.totalCents)}</p>
        <p className="mt-1 text-sm text-slate-400">last 30 days for {tenantName}</p>
      </div>

      {/* Category breakdown */}
      {categories.length > 0 && (
        <div className="space-y-2 mb-6">
          <p className="text-xs uppercase tracking-widest text-slate-500 mb-3">By category</p>
          {categories.map(([category, cents]) => (
            <div key={category} className="flex items-center justify-between">
              <span className="text-sm text-slate-300">{category.replace(/_/g, ' ')}</span>
              <span className="text-sm font-medium">{formatDollars(cents ?? 0)}</span>
            </div>
          ))}
        </div>
      )}

      {categories.length === 0 && (
        <p className="text-sm text-slate-400 mb-6">No cost events recorded yet.</p>
      )}

      {/* Footer */}
      <p className="text-xs text-slate-500 border-t border-slate-800 pt-4">
        Why this matters: Per-tenant cost is dominated by Anthropic tokens. The chassis (CF Pages + Supabase + Stripe + Resend) is mostly free tier or near it.
      </p>
    </div>
  );
}
